document.addEventListener('click', function (event) {
  const swatch = event.target.closest('.js-pcard-swatch');
  if (!swatch) return;

  const imageUrl = swatch.dataset.variantImage;
  if (!imageUrl) return;

  event.preventDefault();

  if ('ontouchstart' in window) {
    const wrapper = swatch.closest('.product-card__wrapper');
    if (wrapper && document.activeElement) {
      document.activeElement.blur();
    }
  }

  const card = swatch.closest('.product-card__wrapper') || swatch.closest('.product-card--overlay') || swatch.closest('[class^="product-card"]');
  if (!card) return;

  const mainImg = card.querySelector('.product-card__image--main img, .pcard__media img');
  if (!mainImg) return;

  mainImg.src = imageUrl;
  if (mainImg.srcset) {
    mainImg.srcset = imageUrl;
  }

  const allSwatches = swatch.closest('.swatches');
  if (allSwatches) {
    allSwatches.querySelectorAll('.swatch-color').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    swatch.classList.add('is-selected');
  }
});